import { useEffect, useState } from 'react';
import { useAuthStore } from '../stores';
import { fetchFeatureFlags } from '../lib/featureFlags';

/**
 * Returns the caller's variant for `flagKey`, defaulting to `'control'`
 * until the flag assignment loads (or if the flag is unknown/unset).
 */
export function useFeatureFlag(flagKey: string, fallback = 'control'): string {
  const accessToken = useAuthStore((s) => s.accessToken);
  const [variant, setVariant] = useState(fallback);

  useEffect(() => {
    let mounted = true;

    fetchFeatureFlags(accessToken).then((flags) => {
      if (mounted && flags[flagKey]) {
        setVariant(flags[flagKey]);
      }
    });

    return () => {
      mounted = false;
    };
  }, [accessToken, flagKey]);

  return variant;
}
